import * as React from 'react';
import * as autoBind from 'react-autobind';
import Strings from '../../globals/Strings';
import {TscThemeName, SlideToggle} from '@techsmith/tsc-cloud-style-guide';
import Constants, {ModalStates} from '../../globals/Constants';
import FeedbackUserService from '../../services/FeedbackUserService/FeedbackUserService';
import {Link} from 'react-router-dom';
import {nullModalEventHandlersFactory} from '../../types/ModalEventHandlers';
import Config from '../../globals/Config';
import {SettingsMenuProps} from './SettingsMenuContainer';

export default class SettingsMenu extends React.Component<SettingsMenuProps, {}> {
   constructor(props: SettingsMenuProps) {
      super(props);
      autoBind(this);
   }

   onChangeTheme(event: React.MouseEvent<HTMLElement>): void {
      const newTheme = this.props.themeName === TscThemeName.dawn ? TscThemeName.dusk : TscThemeName.dawn;
      FeedbackUserService.setTheme(newTheme);
   }

   onClickManageGroups(): void {
      this.props.setModalState(ModalStates.manageReviewerGroups, nullModalEventHandlersFactory());
   }

   render() {
      const manageGroupsLinkTo = (this.props.location.pathname !== Constants.siteLinks.dashboard && this.props.location.pathname.indexOf(Constants.siteLinks.review) === -1) ? Constants.siteLinks.dashboard : '';

      return (
         <div className="options-menu">
            {Config.user.isAuthenticated && <Link className="setting" to={Constants.siteLinks.preferences}>{Strings.labels.managePreferences}</Link>}
            {Config.user.isAuthenticated && <Link className="setting" to={manageGroupsLinkTo} onClick={this.onClickManageGroups} data-test-id="groups-setting" tabIndex={0}>{Strings.labels.manageGroups}</Link>}
            <div className="setting">
               <SlideToggle labelText={Strings.labels.useDarkTheme} onClick={this.onChangeTheme} isChecked={this.props.themeName === TscThemeName.dusk}/>
            </div>
            <Link className="setting" to={Constants.siteLinks.tos}>{Strings.labels.termsOfService}</Link>
            <a className="setting" target="_blank" href={Constants.siteLinks.help.center}>{Strings.labels.helpCenter}</a>
         </div>
      );
   }
}
